var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  "+_vm._s(_vm.capitalized)+"\n  "),(!_vm.capitalized && _vm.col.dashIfEmpty)?[_c('span',{staticClass:"text-muted"},[_vm._v("—")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }